/** İptal koşulları ve diğer açıklamalar menü grubu */
export const OTHER_DESCRIPTIONS_GROUP_KEY = 'other_descriptions';

export const CANCELLATION_TERMS_FIELD_KEY = 'cancellation_terms';
export const CANCELLATION_TERMS_SECTION_ID = 'cancellation-terms';

export function hasMeaningfulHtml(value: unknown): boolean {
    if (value == null) return false;
    const str = typeof value === 'string' ? value : String(value);
    const stripped = str.replace(/<[^>]*>/g, '').replace(/&nbsp;/gi, ' ').trim();
    return stripped.length > 0;
}

export function slugifySectionId(title: string, fallback: string): string {
    const slug = title
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
    return slug || fallback;
}

/**
 * Repeater başlığında {{lang_key}} veya @lang_key kullanıldıysa çeviri anahtarına çözümler.
 */
export function resolveRepeaterSectionTitle(
    rawTitle: string | undefined | null,
    fallback: string,
    t?: (key: string, defaultValue?: string) => string,
): string {
    const title = (rawTitle ?? '').trim();
    if (!title) return fallback;

    if (t) {
        const braceMatch = title.match(/^\{\{([^}]+)\}\}$/);
        if (braceMatch) {
            const key = braceMatch[1].trim();
            return t(key, fallback);
        }
        if (title.startsWith('@')) {
            const key = title.slice(1).trim();
            return key ? t(key, fallback) : fallback;
        }
    }

    return title;
}

export function isOtherDescriptionsGroup(groupKey?: string): boolean {
    return groupKey === OTHER_DESCRIPTIONS_GROUP_KEY;
}
